import { connect } from 'react-redux';
import { goBack, push } from 'connected-react-router';
import LeaseSelectorPage from '@rental-manager/pages/Onboarding/LeaseSelectorPage/LeaseSelector.component';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import { saveLeaseId, saveRentalProtectionFeature } from '@rental-manager/actions/OnboardingActions';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import paths from '@rental-manager/pathsManifest';
import { pageFlows } from '@rental-manager/pages/Dashboard/SetupNewTermModal/pageFlows';
import { resetNewTermSettings, saveNewTermSettings } from '@rental-manager/actions/DashboardActions';
import FeaturePermissionTypes from '@rental-manager/constants/FeaturePermissionTypes';
import { toggleFeature } from '@rental-manager/actions/requests';
import { checkRequestActionSuccess } from '@common/paymentsUtils/api';
import { logError } from '@zg-rentals/log-error';

const mapStateToProps = (state, { propertyId }) => {
  const { leasesForProperty } = state.payments.landlord.onboarding[propertyId];
  const { userConfig } = state.payments.landlord.property;
  const { isRentGuaranteeEnabled } = userConfig;

  return {
    leasesForProperty,
    isRentGuaranteeEnabled,
    user: state.user,
    currentProperty: state.payments.landlord.property.listingDetails,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  onSubmitForRentalProtection: async (leaseId, warningForSelectedLease) => {
    try {
      await dispatch(closeNotification());
      await dispatch(saveLeaseId({ propertyId, leaseId }));
      if (leaseId === null) {
        return dispatch(
          push(baseUrl + paths.dashboard.areYouSurePage, { fromWhere: paths.dashboard.leaseSelectorPage }),
        );
      } else if (warningForSelectedLease === 'ineligibleWarning') {
        return dispatch(push(baseUrl + paths.dashboard.ineligibleLeaseSelected));
      } else if (warningForSelectedLease === 'signingWarning') {
        return dispatch(push(baseUrl + paths.dashboard.unsignedLeaseWarning));
      } else {
        const featureName = FeaturePermissionTypes.RENT_GUARANTEE;
        const response = await dispatch(toggleFeature({ propertyId, featureName, on: true }));
        await checkRequestActionSuccess(response);
        await dispatch(saveRentalProtectionFeature({ propertyId, rentGuarantee: true }));
        await dispatch(saveNewTermSettings({ currentPage: pageFlows.CurrentTenantEndDate }));
        return dispatch(push(baseUrl + paths.dashboard.setupNewTermPage));
      }
    } catch (err) {
      logError({ error: err });
      dispatch(showModalNotification(DEFAULT_ERROR));
      return { error: true };
    }
  },
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(resetNewTermSettings()))
      .then(() => dispatch(push(baseUrl))),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaseSelectorPage);
